import { createFeature, createReducer, on } from '@ngrx/store';
import { TimeTrackingServiceCreateResponseJson } from '@vmspdb/definitions';
import { PaginatedTimeTrackingActions } from './paginated-time-tracking.actions';

export const paginatedTimeTrackingFeatureKey = 'paginatedTimeTracking';

export interface PaginatedTimeTrackingState {
  items: TimeTrackingServiceCreateResponseJson[];
  loading: boolean;
  total: number;
  page: number;
  error: any;
}

export const initialState: PaginatedTimeTrackingState = {
  items: [],
  total: 0,
  page: 0,
  loading: false,
  error: undefined,
};

export const reducer = createReducer(
  initialState,
  on(
    PaginatedTimeTrackingActions.listPaginatedTimeTrackings,
    (state): PaginatedTimeTrackingState => ({ ...state, loading: true }),
  ),
  on(
    PaginatedTimeTrackingActions.listPaginatedTimeTrackingsSuccess,
    (state, { data }): PaginatedTimeTrackingState => ({
      ...state,
      ...data,
      ...data.pagination,
      total: Number(data.pagination?.total),
      loading: false,
    }),
  ),
  on(
    PaginatedTimeTrackingActions.listPaginatedTimeTrackingsFailure,
    (state, { error }): PaginatedTimeTrackingState => ({
      ...state,
      error,
      loading: false,
    }),
  ),
);

export const paginatedTimeTrackingFeature = createFeature({
  name: paginatedTimeTrackingFeatureKey,
  reducer,
});
